{
  "nl": {
    "ai": {
      "assistant": {
        "all_projects": "Alle projecten",
        "cap": {
          "action": "Start een nieuw gesprek",
          "message": "U heeft de gespreksbeperking bereikt."
        },
        "empty_state": {
          "subtitle": "Stel me alles over uw klanten",
          "title": "Hoe kan ik u helpen?"
        },
        "errors": {
          "budget_reached": "Het AI-budget van deze maand is opgebruikt. Neem contact op met Ziggu om het te verhogen.",
          "generic": "Er is iets misgegaan. Probeer het opnieuw."
        },
        "history": {
          "empty": "Nog geen vorige gesprekken",
          "title": "Vorige gesprekken"
        },
        "input": {
          "disclaimer": "Resultaten kunnen onnauwkeurig zijn. Controleer belangrijke informatie altijd.",
          "hint": "Enter om te verzenden · Shift+Enter voor nieuwe regel",
          "placeholder": "Vraag over uw klanten..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Hoe stel ik notificaties in?",
          "help_project_settings": "Waar vind ik project-instellingen?",
          "open_decisions": "Welke beslissingen staan nog open?",
          "unassigned_units": "Welke units hebben nog geen klant?"
        },
        "support_cta": {
          "action": "Neem contact op met support",
          "prompt": "Antwoord niet wat u zocht?"
        }
      },
      "settings": {
        "budget": {
          "description": "Maximale kost per maand voor AI-gebruik (test-fase). Wordt herberekend op basis van token-verbruik van alle gesprekken deze maand.",
          "free_label": "Gratis budget",
          "override_help": "Laat leeg om het pakketbedrag te gebruiken ({amount}).",
          "override_label": "Afwijkend gratis budget",
          "paid_label": "Betaald budget",
          "save": "Opslaan",
          "title": "Maandelijks budget",
          "total_label": "Totaal budget",
          "usage_label": "Verbruikt deze maand",
          "use_package_amount": "Pakketbedrag gebruiken"
        },
        "description": "Configuratie voor AI-functies binnen jullie organisatie.",
        "title": "AI-instellingen",
        "usage": {
          "description": "Hoeveel van het AI-tegoed van deze maand verbruikt is. Bij 100% stoppen de AI-functies tot het tegoed volgende maand opnieuw start.",
          "title": "AI-verbruik"
        }
      },
      "ticket_assistant": {
        "actions": {
          "adjust": "Aanpassen",
          "ask": "Vragen",
          "draft": "Antwoord opstellen",
          "draft_empty": "Nog geen berichten om op te antwoorden",
          "follow_up": "Vervolgvraag",
          "follow_up_stop": "Stoppen met vervolgvraag",
          "new": "Nieuwe vraag",
          "summary": "Vat gesprek samen",
          "summary_empty": "Nog geen berichten om samen te vatten",
          "use_as_reply": "Als antwoord gebruiken"
        },
        "adjusting_draft": "Aanpassing van dit concept",
        "beta": "Bèta",
        "budget": {
          "description": "Het AI-budget van deze maand is opgebruikt. Eerdere antwoorden blijven beschikbaar.",
          "request": "We hebben het AI-budget van deze maand opgebruikt en willen het graag verhogen.",
          "request_low": "We hebben het AI-budget van deze maand bijna opgebruikt en willen het graag verhogen.",
          "title": "AI-budget bereikt",
          "warn": "{percent}% van het AI-budget van deze maand gebruikt."
        },
        "cap": "Deze chat is lang geworden. Stel liever een nieuwe vraag.",
        "collapse": "Assistent verbergen",
        "conversation": "Gesprek",
        "digest": {
          "decisions_open": "geen open beslissingen | 1 open beslissing | {count} open beslissingen",
          "installments_unpaid": "geen openstaande schijven | 1 openstaande schijf | {count} openstaande schijven",
          "issues_open": "geen open nazorgmeldingen | 1 open nazorgmelding | {count} open nazorgmeldingen",
          "nothing_open": "Niets open voor deze unit",
          "overdue": "{count} te laat",
          "title": "In één oogopslag"
        },
        "earlier_answers": "Eerdere antwoorden",
        "empty": "Vraag iets over dit gesprek, of begin met een van deze.",
        "expand": "Assistent tonen",
        "following_up": "Vervolgvraag op dit antwoord",
        "footer": "Alleen zichtbaar voor jou. Antwoorden worden door AI gemaakt en kunnen fouten bevatten.",
        "input": {
          "adjust_draft": "Pas dit concept aan, bv. korter of formeler",
          "follow_up": "Stel een vervolgvraag",
          "label": "Je vraag",
          "placeholder": "Vraag iets over dit gesprek"
        },
        "links": {
          "aftercare": "Nazorg",
          "decisions": "Beslissingen",
          "financials": "Financiën"
        },
        "placeholders": {
          "confirm": {
            "accept": "Toch versturen",
            "header": "Versturen met open plekken?",
            "message": "De assistent liet 1 plek open in dit antwoord die je nog niet hebt ingevuld. | De assistent liet {count} plekken open in dit antwoord die je nog niet hebt ingevuld."
          },
          "remaining": "nog 1 in te vullen | nog {count} in te vullen"
        },
        "replace_reply": {
          "confirm": {
            "accept": "Vervangen",
            "header": "Je tekst vervangen?",
            "message": "Het concept vervangt de tekst in het antwoordveld."
          }
        },
        "suggestions": {
          "history": "Wat is de geschiedenis met deze klant?",
          "issues_open": "Hoeveel opleverpunten staan nog open?",
          "undecided": "Wat heeft deze klant nog niet beslist?"
        },
        "thinking": "De assistent is bezig...",
        "title": "Assistent"
      }
    }
  }
}
